import AppClearbitIcon from '~/images/sidebar/AppClearbit.svg';
import CheckIcon from '~/images/sidebar/Check.svg';
import FreeToolsIcon from '~/images/sidebar/FreeTools.svg';
import GoIcon from '~/images/sidebar/Go.svg';

import styles from './styles';

const appNames = {
  x: 'x',
  clearbit: 'clearbit',
};

const APPS = [
  {
    name: appNames.x,
    title: 'Clearbit Platform',
    text: 'app.clearbit.com',
    link: '#',
    current: true,
  },
  {
    name: appNames.clearbit,
    title: 'Tools and APIs',
    text: 'dashboard.clearbit.com',
    link: 'https://dashboard.clearbit.com/',
    current: false,
  },
];

const Icon = ({ appName, className, ...props }) => {
  switch (appName) {
    case appNames.x:
      return <AppClearbitIcon className={className} {...props} />;
    case appNames.clearbit:
      return <FreeToolsIcon className={className} {...props} />;
  }
};

const AppLink = ({ app, classes }) => (
  <div className={classnames(classes.app, 'rounded-md')}>
    <div className={classes.appDetailContainer}>
      <Icon className={classes.appIcon} appName={app.name} />
      <div className={classes.appDetail}>
        <span className={classes.appTitle}>{app.title}</span>
        <span className={classes.appLinkText}>{app.text}</span>
      </div>
    </div>
    {app.current ? <CheckIcon /> : <GoIcon className={classes.arrow} />}
  </div>
);

const AppSwitch = ({ classes }) => {
  return (
    <div className={classes.section}>
      <div className={classes.appContainer}>
        {APPS.map((app) => {
          return app.current ? (
            <AppLink key={app.name} app={app} classes={classes} />
          ) : (
            <a key={app.name} href={app.link}>
              <AppLink key={app.name} app={app} classes={classes} />
            </a>
          );
        })}
      </div>
    </div>
  );
};

AppSwitch.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppSwitch);
